import { apiClient } from '@/lib/api.ts'

export function getCalendarSyncStatus() {
  return apiClient.get('/calendar-sync/status')
}

export function runCalendarSyncNow() {
  return apiClient.post('/calendar-sync/run-now', {})
}

export function restoreDeletedAppointments(
  params: { from: string; to: string; dryRun: boolean; tanssSupportIds?: string[] },
) {
  return apiClient.post('/calendar-sync/restore-deleted', params)
}

export function restoreOutlookTitles(params: { dryRun: boolean; m365EventIds?: string[] }) {
  return apiClient.post('/calendar-sync/restore-outlook-titles', params)
}
